module.exports = __webpack_public_path__ + "media/promotional/paragliding-258e5500.jpeg";